import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const inventorySlice = createSlice({
  name: 'inventory',
  initialState: {
    activeTab: 'equipment' as
      | 'equipment'
      | 'software'
      | 'services'
      | 'miscellaneous',
  },
  reducers: {
    updateActiveTab: (
      state,
      action: PayloadAction<
        'equipment' | 'software' | 'services' | 'miscellaneous'
      >,
    ) => {
      state.activeTab = action.payload;
    },
  },
});

export const { updateActiveTab } = inventorySlice.actions;

export const { reducer: inventoryReducer } = inventorySlice;
